import type {Ref} from 'react'
import {cnLegacy} from 'utils'
import spriteHref from './generated/sprite.svg'
import type {IconProps} from './types'

export function Icon({
  icon,
  size = 16,
  className,
  ref,
}: IconProps & {ref?: Ref<SVGSVGElement>}) {
  return (
    <svg
      width={size}
      height={size}
      ref={ref}
      fill='currentColor'
      className={cnLegacy('whnue-icon', className)}
    >
      <use xlinkHref={`${spriteHref}#${icon}`}></use>
    </svg>
  )
}
